import { Flex, Radio, Typography } from "antd";

import styles from "./radioButton.module.css";
import { CountBadge } from "ui/CountBadge";
import { COUNT_BADGE_TYPE, countBadgeColorMap } from "interfaces";

interface IProps {
  value: string | boolean | undefined;
  className?: string;
  count?: string | number;
  colored?: "grey" | "white";
  countBadgeProps?: {
    color?: keyof typeof countBadgeColorMap;
    countBadge?: "badge" | "text";
  };
}

function Count({
  count,
  color = "primary",
  countBadge = COUNT_BADGE_TYPE.TEXT,
}: IProps["countBadgeProps"] & { count: number | string }) {
  if (countBadge === COUNT_BADGE_TYPE.BADGE) {
    return <CountBadge count={count} color={color} />;
  }
  return <Typography.Text className={styles.count}>({count})</Typography.Text>;
}

export const RadioButton: React.FC<IProps & React.ComponentProps<typeof Radio.Button>> = ({
  value,
  className,
  count,
  colored,
  children,
  countBadgeProps,
  ...props
}) => {
  const isCountBadge = countBadgeProps?.countBadge === COUNT_BADGE_TYPE.BADGE;
  return (
    <Radio.Button
      value={value}
      {...props}
      className={`${styles.radioButton} ${className ?? ""} ${colored === "grey" ? styles.grey : ""}`}
    >
      <Flex className={styles.textBlock} gap={isCountBadge ? 2 : 0} align={isCountBadge ? "center" : ""}>
        <Typography.Text className={styles.text}>{children}</Typography.Text>
        {count && (
          <Count
            count={count}
            color={countBadgeProps?.color ?? "basic"}
            countBadge={countBadgeProps?.countBadge ?? COUNT_BADGE_TYPE.TEXT}
          />
        )}
      </Flex>
    </Radio.Button>
  );
};
